// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__3jhXt","itemTitle":"ClientEmergencyInfo_itemTitle__cto2Q","itemText":"ClientEmergencyInfo_itemText__kMRNn"};